module.exports = __webpack_public_path__ + "static/img/company_logo.5bd0fd77.png";